import { changeRangeValueAction } from './changeRangeValueAction';

export const changeTotalAreaMaxAction = (value: number): ReturnType<typeof changeRangeValueAction> =>
  changeRangeValueAction({ fieldName: 'totalArea', rangeValueKey: 'max', value });
